<template>
  <v-card tile flat color="transparent">
    <v-card-title>
      <v-row>
        <v-col cols="2"></v-col>
        <v-col>Discussion</v-col>
      </v-row>
    </v-card-title>

    <v-card-text v-if="discussions && discussions.length">
      <v-fade-transition mode="out-in" group>
        <v-row
          v-for="discussion in discussions"
          :key="discussion.id"
          align="baseline"
        >
          <v-col cols="2" align="right">
            <div class="subtitle-2">{{ discussion.created_by.name }}</div>
          </v-col>
          <v-col cols="10">
            <div v-html="discussion.body" />
            <div>
              {{ discussion.created_at }}
              <div
                class="d-inline"
                v-if="discussion.created_by.id == $authUser.id"
              >
                <v-btn xSmall color="secondary" text>Edit</v-btn>
                <span> or </span>
                <v-btn xSmall color="secondary" text>delete</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-fade-transition>
    </v-card-text>

    <v-card-text v-else>
      <v-row>
        <v-col offset="2" cols="10">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>

          <div v-else>No discussions found.</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DiscussionsCard',
  props: {
    discussions: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
